<template>
  <v-app>
    <v-main>
      <LookupForm/>
    </v-main>
  </v-app>
</template>

<script>
import LookupForm from './components/LookupForm';

export default {
  name: 'App',

  components: {
    LookupForm,
  },

  data: () => ({
    //
  }),
};
</script>
